import React from 'react';

const AddressMap = () => {
    return (
        <div className="mapa-container">
            <iframe
                title="Fragata Argentina 2063, Pilar, Buenos Aires"
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3289.1256628034166!2d-58.90325615767212!3d-34.474336291032714!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x477d878e130efce1%3A0xcec2131a4c687bb7!2sSeguridad%20Privada%20%7C%20ARMAT03%20%7C%20Guardias%20y%20Vigilancia!5e0!3m2!1ses!2sar!4v1769723567450!5m2!1ses!2sar" 
                aria-hidden="false"
                className='mapa'
            />
        </div>
    );
};
export { AddressMap };
